import React from 'react'

function Configuracoes() {
  return (
    <div>Configuracoes</div>
  )
}

export default Configuracoes